$( document ).ready(function() {
    var tour;
    var lang = $('html').attr('lang');

    // Define the tour!
    switch (lang) {
        case 'fr':
            tour = {
                id: "new-program-tour",
                i18n: {
                    nextBtn: "Suivant",
                    prevBtn: "Précédent",
                    doneBtn: "Fermer"
                },
                steps: [
                    {
                        target: document.querySelector("#program_isPublic"),
                        title: "Publique ou privé",
                        content: "Un programme publique pourra être visible par les autres membres et être partagé.",
                        placement: "bottom",
                        arrowOffset: "left",
                        xOffset: "-10px"
                    },
                    {
                        target: document.querySelector("#sg-bottom-page-controls-container"),
                        title: "Glisser des exercices",
                        content: "- Ouvrer la barre<br>- Chercher un exercice<br>- Glisser le dans le programme.",
                        placement: "top",
                        arrowOffset: "left",
                        xOffset: "10px",
                        fixedElement: true
                    },
                    {
                        target: document.querySelector("#exercises_filter_showOnlyFavorites"),
                        title: "Exercices favoris",
                        content: "Cocher pour n'afficher que vos exercices favoris.",
                        placement: "top",
                        arrowOffset: "230",
                        xOffset: "-245px",
                        yOffset: "-9px",
                        fixedElement: true
                    },
                    {
                        target: document.querySelector("#program_description"),
                        title: "Titre",
                        content: "Choisir un titre pour votre programme il s'écrira automatiquement dans le carré",
                        placement: "bottom",
                        arrowOffset: "left",
                        xOffset: "-10px"
                    },
                    {
                        target: document.querySelector(".sg-program-editor div ul li .fa"),
                        title: "Ajouter des jours",
                        content: 'Vous pouvez « Copier » une journée et même une semaine entière pour sauver du temps.',
                        placement: "bottom",
                        arrowOffset: "left",
                        xOffset: "-25px",
                        yOffset: "5px",
                        onNext: function() {
                            $('.hopscotch-bubble').addClass('last-bubble');
                        }
                    },
                    {
                        target: document.querySelector(".sg-program-editor"),
                        title: "Tour terminé",
                        content: 'Autre trucs:<br>- Vous pouvez remplacer n\'import quel excercice en glissant un autre excercice par dessus.<br>- Changer d\'option du carré en cliquant sur l\'engrenage.',
                        xOffset: "center",
                        yOffset: "300px",
                        placement: "top",
                        arrowWidth: 0,
                        showPrevButton: false,
                        fixedElement: true
                    }
                ],
                showPrevButton: true,
                scrollTopMargin: 100,
                showCloseButton: true,
                onStart: function() {
                    $('.start-tour').addClass('tour-active');
                },
                onClose: function() {
                    $('.start-tour').removeClass('tour-active');
                    $('.hopscotch-bubble').removeClass('last-bubble');
                },
                onEnd: function() {
                    $('.start-tour').removeClass('tour-active');
                }
            };
            break;
        case 'en':
            tour = {
                id: "new-program-tour",
                steps: [
                    {
                        target: document.querySelector("#program_isPublic"),
                        title: "Public or private",
                        content: "Public program will be visible to other members and to be sharable.",
                        placement: "bottom",
                        arrowOffset: "left",
                        xOffset: "-10px"
                    },
                    {
                        target: document.querySelector("#sg-bottom-page-controls-container"),
                        title: "Drag and drop exercises",
                        content: "- Open the bar<br>- Search exercises<br>- Drag in the program",
                        placement: "top",
                        arrowOffset: "left",
                        xOffset: "10px",
                        fixedElement: true
                    },
                    {
                        target: document.querySelector("#exercises_filter_showOnlyFavorites"),
                        title: "Favorite exercises",
                        content: "Check to show only your favorite exercises.",
                        placement: "top",
                        arrowOffset: "230",
                        xOffset: "-245px",
                        yOffset: "-9px",
                        fixedElement: true
                    },
                    {
                        target: document.querySelector("#program_description"),
                        title: "Title",
                        content: "Choose a title for your program it will be written automatically in the square.",
                        placement: "bottom",
                        arrowOffset: "left",
                        xOffset: "-10px"
                    },
                    {
                        target: document.querySelector(".sg-program-editor div ul li .fa"),
                        title: "Add days",
                        content: 'You can "copy" a day and even a whole week to save time.',
                        placement: "bottom",
                        arrowOffset: "left",
                        xOffset: "-25px",
                        yOffset: "5px",
                        onNext: function() {
                            $('.hopscotch-bubble').addClass('last-bubble');
                        }
                    },
                    {
                        target: document.querySelector(".sg-program-editor"),
                        title: "Completed tour",
                        content: 'Other stuff:<br>- You can replace anything exercise by slipping over another exercise.<br>- Change the square option by clicking on the same gear.',
                        xOffset: "center",
                        yOffset: "300px",
                        placement: "top",
                        arrowWidth: 0,
                        showPrevButton: false,
                        fixedElement: true
                    }
                ],
                showPrevButton: true,
                scrollTopMargin: 100,
                showCloseButton: true,
                onStart: function() {
                    $('.start-tour').addClass('tour-active');
                },
                onClose: function() {
                    $('.start-tour').removeClass('tour-active');
                    $('.hopscotch-bubble').removeClass('last-bubble');
                },
                onEnd: function() {
                    $('.start-tour').removeClass('tour-active');
                }
            };
            break;
        default:
            tour = "";
    }

    $(".start-tour").on("click", function(){
        // Start the tour!
        hopscotch.startTour(tour);
    });
});
